import { api } from "../../../services/Api";

export function normalizarArquivoPrescricao(arquivo) {
  return {
    ...arquivo,
    nomeOriginal: arquivo?.nomeOriginal || arquivo?.name || "prescricao",
    mimeType: arquivo?.mimeType || arquivo?.type || "application/octet-stream",
  };
}

export function arquivoEhPdf(arquivo) {
  return normalizarArquivoPrescricao(arquivo).mimeType === "application/pdf";
}

export function arquivoEhImagem(arquivo) {
  return normalizarArquivoPrescricao(arquivo).mimeType.startsWith("image/");
}

export async function buscarBlobPrescricao(agendamentoId, prescricao) {
  const resposta = await api.get(
    `/v2/agendaCare/agendamento/${agendamentoId}/prescricoes/${prescricao.id}/download`,
    { responseType: "blob" }
  );

  const arquivo = normalizarArquivoPrescricao(prescricao);
  return new Blob([resposta.data], { type: arquivo.mimeType });
}

export function baixarBlob(blob, nomeArquivo) {
  const url = window.URL.createObjectURL(blob);
  baixarBlobUrl(url, nomeArquivo);
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

export function baixarBlobUrl(url, nomeArquivo) {
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo || "prescricao";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
